import useIsPrinting from './PrintUtilities';
import { useSessionStorage } from './StorageUtilities';

/**
 * Hook used to determine if the current page is a scheduled report or not.
 * @returns {boolean}
 */
export default function useIsScheduledReport() {
    const [scheduledReportVal] = useSessionStorage('scheduledReport', 'false');
    const isPrinting = useIsPrinting();

    return isPrinting && String(scheduledReportVal).toLowerCase() === 'true';
}
